import React, { useContext } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { TopMenu } from '../TopMenu';
import AppContext from '../../contexts/App';
import LayoutContext from '../../contexts/Layout';
import { UmbracoComponentMapping } from '../../Mapping';
import { Snack } from '../../componentsv2/common/Snack';

export const ClassicLayout = ({ followContentLink = async () => {} }) => {
    const {
        state: { action }
    } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);

    const pageComponents = Object.values(action.data?.page?.contentItems || {}).map(cmp => {
        const UmbracoComponent = UmbracoComponentMapping[cmp.nodeTypeAlias];

        if (UmbracoComponent) {
            return <UmbracoComponent {...cmp} followContentLink={followContentLink} key={cmp.id} references={action?.data?.references} width={layout.dimensions.width} />;
        }
    });

    return (
        <View style={StyleSheet.flatten([Styles.container, { height: layout.dimensions.height }])}>
            <TopMenu />
            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ height: '100%', width: '100%' }}>
                {pageComponents?.map(cmp => cmp)}
            </ScrollView>
            <Snack />
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        flexDirection: 'col'
    },
    contentItemWrapper: {
        marginBottom: 10
    },
    text: {
        fontFamily: 'Helvetica',
        fontSize: '16pt'
    }
});
